/**
 * Keeps inactive product-media carousel slides (images, videos, models) out of
 * the keyboard tab order and hidden from assistive tech, since the flickitybee
 * carousel only toggles an ".is-selected" class and never manages focusability
 * of off-screen slide content on its own.
 */
(function () {
  var FOCUSABLE_SELECTOR = 'a[href], button, video, iframe, model-viewer, input, select, textarea, [tabindex]';

  function applyState(wrapper) {
    var isActive = wrapper.classList.contains('is-selected');

    if (isActive) {
      wrapper.removeAttribute('aria-hidden');
      wrapper.removeAttribute('inert');
      wrapper.querySelectorAll('[data-a11y-carousel-hidden]').forEach(function (el) {
        el.removeAttribute('tabindex');
        el.removeAttribute('data-a11y-carousel-hidden');
      });
      return;
    }

    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.setAttribute('inert', '');
    wrapper.querySelectorAll(FOCUSABLE_SELECTOR).forEach(function (el) {
      if (el.getAttribute('tabindex') !== '-1') {
        el.setAttribute('data-a11y-carousel-hidden', 'true');
      }
      el.setAttribute('tabindex', '-1');
    });
  }

  function watch(wrapper) {
    applyState(wrapper);
    new MutationObserver(function () {
      applyState(wrapper);
    }).observe(wrapper, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

  function init(root) {
    var wrappers = (root || document).querySelectorAll('[data-product-single-media-wrapper]');
    if (wrappers.length < 2) return;
    wrappers.forEach(watch);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    init(evt.target);
  });
})();
